import {
  selectRemotePeers,
  selectLocalPeer,
  useHMSStore,
  HMSPeer,
  useHMSActions,
  selectIsConnectedToRoom,
} from "@100mslive/react-sdk";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Peer from "./Peer";
import "./Conference.css";
import StandardColors from "../../../../../../util/StandardColors";
import { StyleSheet } from "../../../../../../typings/StyleSheet";
import { InfiniteScroll, Text } from "grommet";
import Draggable from "react-draggable";
import { useNavigate, useParams } from "react-router-dom";
import {
  IoMicOffSharp,
  IoMicSharp,
  IoVideocam,
  IoVideocamOff,
} from "react-icons/io5";
import { FiMinimize2, FiMaximize2 } from "react-icons/fi";
import { MdCallEnd } from "react-icons/md";
import { useSidebar } from "../../../../context/Sidebar/SidebarContext";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import { useUser } from "../../../../context/User/UserContext";
import HmsVideocallManager from "../../../../../../util/100ms/HmsVideocallManager";
import { Responsive, WidthProvider } from "react-grid-layout";
import { NotificationHelper } from "../../../../../../util/notification/NotificationHelper";
import { MedicalEmergencyHelper } from "../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { observer } from 'mobx-react';
import { useStore } from "../../../../../../Hooks/useStore";
import { VideoCallNotificationHelper } from "../../../../../../util/notification/VideoCallNotificationHelper";
import usersService from "../../IAM/Users/users.service";
import { APIs } from "../../../../../../util/api/APIs";

const ResponsiveGridLayout = WidthProvider(Responsive);

const AudioConference = observer(() => {
  const { rootStore } = useStore();
  const remotePeers = useHMSStore(selectRemotePeers);
  const localPeer = useHMSStore(selectLocalPeer);
  const isConnected = useHMSStore(selectIsConnectedToRoom);

  const iconSize = useMemo(() => 28, []);
  const { medicalEmergencyId, videoCall } = useParams();

  const [selectedPeer, setSelectedPeer] = useState(
    remotePeers.length > 0 ? remotePeers[0] : null
  );
  const [callState, setCallState] = useState({
    audioEnabled: false,
    videoEnabled: false,
    videoListMinimized: false,
  });
  const [windowSize, setWindowSize] = useState({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  });

  useEffect(() => {
    setTimeout(() => {
      let a = 0;
      if (videoCall == "on" && a == 0) {
        a++;
        onVideoButtonClicked();
      }
    }, 100);
  }, [videoCall]);

  const hmsActions = useHMSActions();
  const navigation = useNavigate();
  const { setShowSidebar } = useSidebar();
  const { user } = useUser();
  const [roomId, setRoomId] = useState('');
  const [videoRecordStatus, setVideoRecordStatus] = useState('');
  const [videoToken, setVideoToken] = useState('');

  const getMedical = async () => {
    if (medicalEmergencyId) {
      const medicalEmergencyFromAPI =
        await MedicalEmergencyService.getMedicalEmergency(medicalEmergencyId);
      rootStore.emsStore.handleSelectedEmergency(medicalEmergencyFromAPI);
    }
  }

  useEffect(() => {
    getMedical();

    return () => {
      rootStore.callingStore.handleInComingCall(false);
    }
  }, []);

  const notifyUsers = useCallback(
    async (sentBy: string, messageContent: string, roomId: string) => {
      // const notificationHelper = new NotificationHelper();
      const notificationHelper = new VideoCallNotificationHelper();
      const medicalEmergencyHelper = new MedicalEmergencyHelper();
      let users = [];
      let cognitoUserIdCaptain = null;
      let cognitoUserIdCrew = null;
      if (user == null) return;
      if (rootStore.emsStore.getSelectedEmergency == null) return;

      const videoCallInfo = {
        "navigate": "videoCall",
        "flightId": rootStore.emsStore.getSelectedEmergency.flightId,
        "roomId": roomId,
        "emergencyId": rootStore.emsStore.getSelectedEmergency.id
      }
      console.log("videoCallInfo", videoCallInfo);
      cognitoUserIdCaptain = await medicalEmergencyHelper.findCaptain(
        rootStore.emsStore.getSelectedEmergency.flightId
      );
      cognitoUserIdCrew = await medicalEmergencyHelper.findCrew(
        rootStore.emsStore.getSelectedEmergency.id
      );

      if (cognitoUserIdCaptain) {
        users.push(cognitoUserIdCaptain);
      }
      if (cognitoUserIdCrew) {
        users.push(cognitoUserIdCrew);
      }
      if (users.length != 0) {
        notificationHelper.sendVideoCallNotification(sentBy, messageContent, users, videoCallInfo);
      }
    },
    [rootStore.emsStore.getSelectedEmergency, user]
  );

  const joinCall = async () => {
    // If medicalEmergency is set

    try {
      let videocallRecord = null;
      // notifyUsers(
      //   user?.username ?? "",
      //   "Video call answered by " + user?.username,
      //   ""
      // );
      console.log("selectedMedicalEmergency", medicalEmergencyId, user);
      if (medicalEmergencyId && user) {
        rootStore.loadingStore.setShowLoader(true);
        videocallRecord =
          await MedicalEmergencyService.getVideocallRecordForMedicalEmergency(
            Number.parseInt(medicalEmergencyId)
          );
        let room = videocallRecord.roomId.split(",")[0];
        {
          rootStore.callingStore.getInComingCall
            ?
            notifyUsers(
              user?.username ?? "",
              "Call answered by " + user?.username,
              room
            )
            :
            notifyUsers(
              user?.username ?? "",
              "Call initiated by " + user?.username,
              room
            )
        }
        rootStore.conferenceStore.setRoomId(room);
        if (videocallRecord && rootStore.conferenceStore.getVideoRecordStatus !== 'starting') {
          await MedicalEmergencyService.recordCallStart(room)
            .then((res) => {
              console.log('Video Call Recording Started response', res);
              rootStore.conferenceStore.setVideoRecordStatus('starting');
            })
            .catch((error) => {
              rootStore.conferenceStore.setVideoRecordStatus('starting');
              console.error('Error starting video call recording:', error);
            });
        }
        console.log("hmsActions", hmsActions);
        console.log("videocallRecord", videocallRecord);
        const config = await HmsVideocallManager.joinRoomConfig(
          user.username,
          videocallRecord.roomId.split(",")[0]
        );
        rootStore.conferenceStore.setVideoToken(config.authToken);
        await hmsActions.join(config);
        rootStore.loadingStore.setShowLoader(false);
      }
    } catch (e) {
      rootStore.loadingStore.setShowLoader(false);
    }
  };

  useEffect(() => {
    if (user) {
      joinCall()
        .then((res) => {
          console.log("connected success");
        })
        .catch((e) => {
          console.log("disconnected");
        });
    }

    window.onunload = () => {
      if (isConnected) {
        hmsActions.leave();
      }
    };
    rootStore.sidebarStore.setShowSidebar(false);
  }, [user, rootStore.conferenceStore.getVideoRecordStatus]);

  useEffect(() => {
    return () => {
      if (isConnected) {
        hmsActions.leave();
      }
    };
  }, []);

  useEffect(() => {
    if (localPeer) {
      hmsActions.setLocalAudioEnabled(rootStore.conferenceStore.getAudioStatus);
      hmsActions.setLocalVideoEnabled(rootStore.conferenceStore.getVideoStatus);
    }
  }, [localPeer, rootStore.conferenceStore.getVideoStatus, rootStore.conferenceStore.getAudioStatus]);


  useEffect(() => {
    if (remotePeers.length > 0) {
      setSelectedPeer(remotePeers[0]);
    } else {
      setSelectedPeer(null);
    }
  }, [remotePeers]);

  useEffect(() => {
    console.log("isConnected", isConnected);
  }, [isConnected]);


  const onCallEnd = async () => {
    let fId;
    if (medicalEmergencyId) {
      (async () => {
        try {
          const medicalEmergencyFromAPI = await MedicalEmergencyService.getMedicalEmergency(medicalEmergencyId);
          fId = medicalEmergencyFromAPI.flightId
        } catch (error) {
          console.log("Error in get medical emergency", error);
        }
      })()
    }

    let token;
    try {
      let response = await MedicalEmergencyService.getFcmToken();
      token = response.split("Access Token: ")[1];
      console.log("FCM token response", token);
    } catch (error) {
      console.log("Error fetching FCM token", error);
    }
    if (token) {
      let crewRecord;
      try {
        const medicalEmergencyHelper = new MedicalEmergencyHelper();
        let cognitoUserIdCrew = await medicalEmergencyHelper.findCrewName(medicalEmergencyId);
        console.log("cognitoUserIdCrew", cognitoUserIdCrew);
        if (cognitoUserIdCrew) {
          await usersService.listUsersByUsername(cognitoUserIdCrew)
            .then((res) => {
              crewRecord = res;
            })
            .catch((error) => {
              console.log("Error fetching crew record", error);
            })
        }
      } catch (error) {
        console.log("Error fetching crew name", error);
      }
      console.log("crew user records", crewRecord);
      if (crewRecord && crewRecord[0]["custom:fcmtoken"]) {
        console.log('crewRecord[0]["custom:fcmtoken"]', crewRecord[0]["custom:fcmtoken"])
        let headersList = {
          "Content-Type": "application/json",

          Authorization:
            `Bearer ${token}`,
        };

        let bodyContent = JSON.stringify({
          validate_only: false,

          message: {
            token: crewRecord[0]["custom:fcmtoken"],

            data: {
              type: "VoiceCallEnded",
              flight_id: fId,
              emergency_id: medicalEmergencyId?.toString(),
              content_available: "true",
            },
          },
        });
        try {


          let mesagesendurl;
          if (APIs.BASE_URL.indexOf("sbx") >= 0) {
            mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
          } else if (APIs.BASE_URL.indexOf("poc") >= 0) {
            mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
          } else {
            mesagesendurl = "https://fcm.googleapis.com/v1/projects/skali-inc/messages:send";
          }
          let response = await fetch(
            mesagesendurl,
            {
              method: "POST",

              body: bodyContent,

              headers: headersList,
            }
          );

          let data = await response.text();

          console.log(data);
        } catch (error) {
          console.error("Voice call Api error", error);
        }
      }
    }

    hmsActions.leave();
    if (rootStore.conferenceStore.getRoomId) {
      await MedicalEmergencyService.recordCallStop(rootStore.conferenceStore.getRoomId)
        .then((res) => {
          rootStore.conferenceStore.setVideoRecordStatus('stoping');
          console.log('Video Call Recording stopped successfully', rootStore.conferenceStore.getRoomId);
        })
        .catch((error) => {
          console.error('Error stopped video call recording:', error);
        });
    }
    //navigation("/medical-emergencies/emergency/" + medicalEmergencyId);
    window.close();
    rootStore.sidebarStore.setShowSidebar(true);
  };

  const onMicrophoneClicked = async () => {
    await hmsActions.setLocalAudioEnabled(!rootStore.conferenceStore.getAudioStatus);
    rootStore.conferenceStore.toggleAudioEnabled();
    // setCallState((prev) => {
    //   return {
    //     ...prev,
    //     audioEnabled: !rootStore.conferenceStore.getAudioStatus,
    //   };
    // });
  };

  const onVideoButtonClicked = async () => {
    await hmsActions.setLocalVideoEnabled(!rootStore.conferenceStore.getVideoStatus);
    rootStore.conferenceStore.toggleVideoEnabled();
    // setCallState((prev) => {
    //   return {
    //     ...prev,
    //     videoEnabled: !rootStore.conferenceStore.getVideoStatus,
    //   };
    // });
  };

  const onMinimizeClicked = () => {
    rootStore.conferenceStore.toggleVideoListMinimized();
    // setCallState((prev) => {
    //   return {
    //     ...prev,
    //     videoListMinimized: !rootStore.conferenceStore.getVideoListMinimizeStatus,
    //   };
    // });
  };

  useEffect(() => {
    console.log("selectedPeer", selectedPeer);
  }, [selectedPeer]);

  const layout_large = [
    { i: "videocall-main", x: 0, y: 0, w: 1, h: 9, static: false },
    { i: "footer", x: 0, y: 9, w: 1, h: 1, static: false },
  ];

  const layouts = {
    lg: layout_large,
  };

  useEffect(() => {
    window.addEventListener("resize", (ev) => {
      rootStore.conferenceStore.updateWindowRize(window.innerWidth, window.innerHeight);
    });
  }, []);

  return (
    <>
      {isConnected && user ? (
        <>
          <ResponsiveGridLayout
            layouts={layouts}
            isResizable={false}
            rowHeight={(rootStore.conferenceStore.getWindowHeight - 100) / 10}
            breakpoints={{ lg: 1000 }}
            cols={{ lg: 1 }}
            isDraggable={false}
            verticalCompact={true}
            style={{ height: rootStore.conferenceStore.getWindowHeight }}
          >
            {/* Main grid container */}
            <div key="videocall-main" className={`peers-grid-container ${remotePeers.length === 0 ? 'single-peer' :
                remotePeers.length === 1 ? 'two-peers' :
                  remotePeers.length <= 3 ? 'multiple-peers' : 'many-peers'
              }`}>
              {/* Local peer tile */}
              {localPeer && (
                <div className="peer-tile">
                  <Peer peer={localPeer} />
                </div>
              )}

              {/* Remote peers tiles */}
              {remotePeers.length > 0 ? (
                remotePeers.map((peer) => (
                  <div className="peer-tile" key={peer.id}>
                    <Peer peer={peer} />
                  </div>
                ))
              ) : (
                <div className="no-participants-container">
                  <Text className="no-participants-text">
                    No participants joined yet.
                  </Text>
                </div>
              )}
            </div>

            {/* Footer */}
            <div key="footer" style={styles.footer} className="footer">
              {rootStore.conferenceStore.getVideoStatus ? (
                <IoVideocam
                  onClick={onVideoButtonClicked}
                  color={StandardColors.white}
                  size={iconSize}
                  className="conference-icon"
                />
              ) : (
                <IoVideocamOff
                  onClick={onVideoButtonClicked}
                  color={StandardColors.white}
                  size={iconSize}
                  className="conference-icon"
                />
              )}

              <MdCallEnd
                onClick={onCallEnd}
                color={"red"}
                size={iconSize}
                className="conference-icon"
              />

              {rootStore.conferenceStore.getAudioStatus ? (
                <IoMicSharp
                  onClick={onMicrophoneClicked}
                  color={StandardColors.white}
                  size={iconSize}
                  className="conference-icon"
                />
              ) : (
                <IoMicOffSharp
                  onClick={onMicrophoneClicked}
                  color={StandardColors.white}
                  size={iconSize}
                  className="conference-icon"
                />
              )}
            </div>
          </ResponsiveGridLayout>
          {/* Local Peer floating window */}

          <Draggable>
            <div className="peer-videos-sidebar-container floating-panel-self-video">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="peer-videos-sidebar">
                  <Peer peer={localPeer} />
                </div>
              </div>
            </div>
          </Draggable>
          {/* <Grid columns={size !== "small" ? "medium" : "100%"} gap="small">
          {[{}, {}, {}, {}].map((peer, index) => (
            <Peer peer={undefined} key={index} className={undefined} />
          ))}
        </Grid> */}
          {/* <LocalPeer peer={localPeer} videoEnabled={callState.videoEnabled} /> */}
          {/* {isConnected ? (
            <Draggable>
              <div
                className="floating-panel"
                style={rootStore.conferenceStore.getVideoListMinimizeStatus ? { height: 55 } : {}}
              >
                {rootStore.conferenceStore.getVideoListMinimizeStatus ? (
                  <FiMaximize2
                    className="conference-icon minimize-icon"
                    color="white"
                    onClick={onMinimizeClicked}
                  />
                ) : (
                  <FiMinimize2
                    className="conference-icon minimize-icon"
                    color="white"
                    onClick={onMinimizeClicked}
                  />
                )}
                {rootStore.conferenceStore.getVideoListMinimizeStatus ? (
                  <></>
                ) : (
                  <div className="peer-videos-sidebar-container">
                    <InfiniteScroll
                      step={4}
                      items={remotePeers.slice(1, remotePeers.length)}
                    >
                      {(item: HMSPeer) => (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div className="peer-videos-sidebar">
                            <Peer peer={item} />
                          </div>
                        </div>
                      )}
                    </InfiniteScroll>
                  </div>
                )}
              </div>
            </Draggable>
          ) : (
            <></>
          )} */}
        </>
      ) : (
        <></>
      )}
    </>
  );
});

const styles: StyleSheet = {
  footer: {
    backgroundColor: StandardColors.primary_blue_dark_10,
  },
};

export default AudioConference;
